/* Native details remain usable without JavaScript. No cart or checkout overrides. */
(() => {
  const selector = '[data-pwt-dropdown]';
  const close = (except, restoreFocus = false) => {
    document.querySelectorAll(`${selector}[open]`).forEach(details => {
      if (details === except) return;
      details.open = false;
      if (restoreFocus) details.querySelector('summary')?.focus();
    });
  };
  document.addEventListener('click', event => {
    const details = event.target.closest(selector);
    close(details);
    if (details && event.target.closest('a')) details.open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') close(null, true);
  });
  document.addEventListener('focusin', event => {
    if (!event.target.closest(selector)) close(null);
  });
  document.addEventListener('shopify:section:unload', () => close(null));
})();
